/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BaseDataResponse_FeedbackApplicationResponse_ } from '../models/BaseDataResponse_FeedbackApplicationResponse_';
import type { BaseListDataResponse_FeedbackApplicationResponse_ } from '../models/BaseListDataResponse_FeedbackApplicationResponse_';
import type { CreateUserFeedbackRequest } from '../models/CreateUserFeedbackRequest';
import type { FeedbackApplicationStatus } from '../models/FeedbackApplicationStatus';
import type { UpdateFeedbackApplicationStatusRequest } from '../models/UpdateFeedbackApplicationStatusRequest';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class FeedbackLawyerConsultationService {
    /**
     * List Lawyer Consultation Applications
     * Получение списка заявок на консультацию с юристом с фильтрацией
     * @param status Фильтр по статусу
     * @param userId Фильтр по ID пользователя
     * @param userSearch Поиск по username, email или full_name (частичное совпадение)
     * @param limit Лимит
     * @param offset Смещение
     * @returns BaseListDataResponse_FeedbackApplicationResponse_ Successful Response
     * @throws ApiError
     */
    public static listLawyerConsultationApplicationsApiFeedbackLawyerConsultationGet(
        status?: (FeedbackApplicationStatus | null),
        userId?: (string | null),
        userSearch?: (string | null),
        limit: number = 50,
        offset?: number,
    ): CancelablePromise<BaseListDataResponse_FeedbackApplicationResponse_> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/feedback/lawyer-consultation',
            query: {
                'status': status,
                'user_id': userId,
                'user_search': userSearch,
                'limit': limit,
                'offset': offset,
            },
            errors: {
                401: `Code: authentication_error`,
                422: `Code: validation_error`,
                500: `Code: internal_server_error`,
            },
        });
    }
    /**
     * Create My Lawyer Consultation Application
     * Создание заявки на консультацию с юристом от имени текущего пользователя
     * @param requestBody
     * @returns BaseDataResponse_FeedbackApplicationResponse_ Successful Response
     * @throws ApiError
     */
    public static createMyLawyerConsultationApplicationApiFeedbackLawyerConsultationMePost(
        requestBody: CreateUserFeedbackRequest,
    ): CancelablePromise<BaseDataResponse_FeedbackApplicationResponse_> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/feedback/lawyer-consultation/me',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Code: authentication_error`,
                422: `Code: validation_error`,
                500: `Code: internal_server_error`,
            },
        });
    }
    /**
     * List My Lawyer Consultation Applications
     * Получение своих заявок на консультацию с юристом
     * @param status Фильтр по статусу
     * @param limit Лимит
     * @param offset Смещение
     * @returns BaseListDataResponse_FeedbackApplicationResponse_ Successful Response
     * @throws ApiError
     */
    public static listMyLawyerConsultationApplicationsApiFeedbackLawyerConsultationMeGet(
        status?: (FeedbackApplicationStatus | null),
        limit: number = 50,
        offset?: number,
    ): CancelablePromise<BaseListDataResponse_FeedbackApplicationResponse_> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/feedback/lawyer-consultation/me',
            query: {
                'status': status,
                'limit': limit,
                'offset': offset,
            },
            errors: {
                401: `Code: authentication_error`,
                422: `Code: validation_error`,
                500: `Code: internal_server_error`,
            },
        });
    }
    /**
     * Get My Lawyer Consultation Application
     * Получение своей заявки на консультацию с юристом по ID
     * @param applicationId
     * @returns BaseDataResponse_FeedbackApplicationResponse_ Successful Response
     * @throws ApiError
     */
    public static getMyLawyerConsultationApplicationApiFeedbackLawyerConsultationMeApplicationIdGet(
        applicationId: string,
    ): CancelablePromise<BaseDataResponse_FeedbackApplicationResponse_> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/feedback/lawyer-consultation/me/{application_id}',
            path: {
                'application_id': applicationId,
            },
            errors: {
                401: `Code: authentication_error`,
                404: `Code: feedback_application_not_found`,
                422: `Validation Error`,
                500: `Code: internal_server_error`,
            },
        });
    }
    /**
     * Get Lawyer Consultation Application
     * Получение заявки на консультацию с юристом по ID
     * @param applicationId
     * @returns BaseDataResponse_FeedbackApplicationResponse_ Successful Response
     * @throws ApiError
     */
    public static getLawyerConsultationApplicationApiFeedbackLawyerConsultationApplicationIdGet(
        applicationId: string,
    ): CancelablePromise<BaseDataResponse_FeedbackApplicationResponse_> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/feedback/lawyer-consultation/{application_id}',
            path: {
                'application_id': applicationId,
            },
            errors: {
                401: `Code: authentication_error`,
                404: `Code: feedback_application_not_found`,
                422: `Validation Error`,
                500: `Code: internal_server_error`,
            },
        });
    }
    /**
     * Update Lawyer Consultation Application Status
     * Обновление статуса заявки на консультацию с юристом
     * @param applicationId
     * @param requestBody
     * @returns BaseDataResponse_FeedbackApplicationResponse_ Successful Response
     * @throws ApiError
     */
    public static updateLawyerConsultationApplicationStatusApiFeedbackLawyerConsultationApplicationIdStatusPut(
        applicationId: string,
        requestBody: UpdateFeedbackApplicationStatusRequest,
    ): CancelablePromise<BaseDataResponse_FeedbackApplicationResponse_> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/feedback/lawyer-consultation/{application_id}/status',
            path: {
                'application_id': applicationId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Code: authentication_error`,
                404: `Code: feedback_application_not_found`,
                422: `Code: validation_error`,
                500: `Code: internal_server_error`,
            },
        });
    }
}
